import React from 'react';
import { Shield, MessageCircle, Sparkles } from 'lucide-react';

const ChatFAB = ({ onClick, isOpen }) => {
  if (isOpen) return null;

  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Ask Niko - Clinical Intelligence"
    >
      {/* Pulse Ring */}
      <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[var(--niko-teal)] to-[var(--niko-green)] animate-ping opacity-20" />
      
      {/* Main Button */}
      <div className="relative w-14 h-14 rounded-full bg-gradient-to-br from-[var(--niko-teal)] to-[var(--niko-green)] shadow-lg flex items-center justify-center transform group-hover:scale-110 transition-all duration-300 group-hover:shadow-xl group-hover:shadow-[var(--niko-teal)]/30">
        <Shield className="w-6 h-6 text-white" />
        
        {/* Online Indicator */}
        <span className="absolute -top-0.5 -right-0.5 w-4 h-4 bg-[var(--niko-green)] rounded-full border-2 border-white flex items-center justify-center">
          <Sparkles className="w-2.5 h-2.5 text-white" />
        </span>
      </div>

      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <div className="bg-[var(--bg-dark)] text-white text-sm font-medium px-4 py-2 rounded-lg whitespace-nowrap shadow-lg">
          Ask Niko
          <div className="absolute top-full right-6 w-3 h-3 bg-[var(--bg-dark)] transform rotate-45 -translate-y-1.5" />
        </div>
      </div>
    </button>
  );
};

export default ChatFAB;
